function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import { isBrowser } from '@finect/front-utils/isBrowser';
import { objectToArrayOfObjects } from '@finect/front-utils/objectToArrayOfObjects';
import { arrayOfObjectsToObject } from '@finect/front-utils/arrayOfObjectsToObject';
import { layers as defaultLayers } from './layers/layers';
import { sendEvent } from './actions';
var SESSION_VARIABLES = ['user', 'pill', 'event'];
var gtmId = process.env.FINECT_GTM_CONTAINER || null;
var googletag = null;
export var getObject = function getObject(layer, input) {
  var _layer$contextualize = layer.contextualize,
    contextualize = _layer$contextualize === void 0 ? function (params) {
      return {};
    } : _layer$contextualize,
    _layer$modelize = layer.modelize,
    modelize = _layer$modelize === void 0 ? function (params) {
      return {};
    } : _layer$modelize;
  if (layer.type === 'clearVariables') {
    var attrs = contextualize(input.params);
    var variables = attrs.variables.filter(function (variable) {
      return !SESSION_VARIABLES.includes(variable);
    });
    var object = variables.reduce(function () {
      var acum = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var current = arguments.length > 1 ? arguments[1] : undefined;
      return _objectSpread(_objectSpread({}, acum), _defineProperty({}, current, undefined));
    }, {});
    return _objectSpread(_objectSpread(_objectSpread({}, {
      event: 'SPANavigate'
    }), object), {}, {
      targeting: undefined
    });
  }
  if (!layer.event && !layer.model && !layer.modelize) {
    var _attrs = contextualize(input.params);
    return _defineProperty({}, layer.name, _objectSpread({}, _attrs));
  }
  if (layer.event) {
    var _ref4;
    var _attrs2 = contextualize(input.params);
    var models = modelize(input.params);
    var targeting = _attrs2.targeting || {};
    if (!layer.name) {
      return _objectSpread({
        event: layer.action || layer.type
      }, _attrs2);
    }
    return _ref4 = {
      event: layer.type
    }, _defineProperty(_ref4, layer.name, _objectSpread(_objectSpread({}, layer.action ? _defineProperty({}, layer.action, layer.model ? Array.isArray(models) ? _defineProperty({}, "".concat(layer.model, "s"), models) : models : true) : {}), _attrs2)), _defineProperty(_ref4, "targeting", targeting), _ref4;
  }
  switch (layer.type) {
    case 'impressions':
      {
        if (!input.params.models.length) {
          return null;
        }
        return _defineProperty({}, layer.name, _objectSpread({
          impressions: layer.modelize(input.params)
        }, contextualize(input.params)));
      }
    case 'pageType':
      {
        return _objectSpread(_defineProperty({}, layer.type, input.params.pageType || ''), input.params.pageId ? {
          pageId: input.params.pageId
        } : {});
      }
    case 'view':
      {
        var _attrs3 = contextualize(input.params);
        return _defineProperty({}, layer.name, _objectSpread(_defineProperty({}, layer.action, layer.modelize ? layer.modelize(input.params) : {}), _attrs3));
      }
    default:
      {
        return null;
      }
  }
};
export var getDataLayerData = function getDataLayerData(_ref7, layers) {
  var id = _ref7.id,
    type = _ref7.type,
    params = _ref7.params;
  var matchingLayer = layers.find(function (layer) {
    return layer.id === id && layer.type === type;
  });
  if (!matchingLayer) {
    return [];
  }
  var payload = getObject(matchingLayer, {
    id: id,
    type: type,
    params: params
  });
  if (!payload) {
    return [];
  }
  return [payload, matchingLayer];
};
export var getDataLayer = function getDataLayer(_ref8) {
  var id = _ref8.id,
    type = _ref8.type,
    params = _ref8.params;
  var layers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultLayers;
  var _getDataLayerData = getDataLayerData({
      id: id,
      type: type,
      params: params
    }, layers),
    _getDataLayerData2 = _slicedToArray(_getDataLayerData, 1),
    payload = _getDataLayerData2[0];
  return payload;
};
export var dataLayer = function dataLayer(request) {
  var layers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultLayers;
  var _getDataLayerData3 = getDataLayerData(request, layers),
    _getDataLayerData4 = _slicedToArray(_getDataLayerData3, 2),
    payload = _getDataLayerData4[0],
    definition = _getDataLayerData4[1];
  var isGtmLoaded = window && Boolean(window.google_tag_manager);
  var _request$callback = request.callback,
    callback = _request$callback === void 0 ? function () {} : _request$callback;
  if (!payload) {
    callback();
    return;
  }
  if (!isBrowser()) {
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.__finect_dataLayer = window.__finect_dataLayer || {
    variables: []
  };
  var variablesList = objectToArrayOfObjects(payload, 'variable', 'value');
  var variablesToReset = arrayOfObjectsToObject(variablesList.filter(function (_ref9) {
    var value = _ref9.value;
    return value !== undefined;
  }).filter(function (_ref10) {
    var value = _ref10.value;
    return !SESSION_VARIABLES.includes(value);
  }), 'variable', 'value');
  window.__finect_dataLayer.variables = [].concat(_toConsumableArray(window.__finect_dataLayer.variables), _toConsumableArray(Object.keys(variablesToReset)));
  window.dataLayer.push(request.callback && isGtmLoaded ? _objectSpread(_objectSpread({}, payload), {}, {
    eventCallback: function eventCallback(id) {
      if (gtmId !== id) {
        console.log("finect-gtm: eventCallback rejects for ".concat(id));
        return;
      }
      console.log("finect-gtm: eventCallback execution for ".concat(id), request);
      callback();
    },
    eventTimeout: 2000
  }) : payload);
  !isGtmLoaded && request.callback && callback();
  if (definition && definition.sendEvent) {
    sendEvent(payload);
  }
  if (!payload.hasOwnProperty('event')) {
    window.dataLayer.push({
      event: 'sync'
    });
  }
  if (payload.pageType) {
    if (!googletag) {
      googletag = window.googletag = window.googletag || {};
      googletag.cmd = googletag.cmd || [];
    }
    googletag.cmd.push(function () {
      if (googletag && googletag.pubads) {
        googletag.pubads().setTargeting('pageType', payload.pageType);
        googletag.pubads().setTargeting('pageId', payload.pageId || null);
      }
    });
    return {
      targeting: payload
    };
  }
  return payload;
};